<template>
  <div>
    <HeaderYM />
    <section class="container mt-5">
      <slot />
    </section>
    <FooterYM />
  </div>
</template>
